module.exports = __webpack_public_path__ + "fbed0037705f1e03caa92a5df05f6629.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/2000_l_70.mp3
// module id = 450
// module chunks = 0